export default __webpack_public_path__ + "static/media/Netccn-One-Logo-Color.88b9ab84.svg";